import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CdTimerComponent } from 'angular-cd-timer';
import { ToasterService } from 'angular2-toaster';
import { DxTextBoxComponent, DxValidatorComponent } from 'devextreme-angular';
import { ConfigService } from 'src/app/services/config.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-login-with-otp',
  templateUrl: './login-with-otp.component.html',
  styleUrls: ['./login-with-otp.component.scss']
})
export class LoginWithOtpComponent implements OnInit {
  phoneNum: any;
  selectedCountryCode: any;
  otpNewValue: any = null;
  url: any;

  constructor(private config: ConfigService,
    private toasterService: ToasterService, public router: Router, private loginService:LoginService) { }

  @ViewChild("basicTimer", { static: true }) basicTimer: CdTimerComponent;
  @ViewChild("otpText1", { static: false }) public otpBox1: DxTextBoxComponent;
  @ViewChild("otpText2", { static: false }) public otpBox2: DxTextBoxComponent;
  @ViewChild("otpText3", { static: false }) public otpBox3: DxTextBoxComponent;
  @ViewChild("otpText4", { static: false }) public otpBox4: DxTextBoxComponent;
  @ViewChild("otpText5", { static: false }) public otpBox5: DxTextBoxComponent;
  @ViewChild("otpText6", { static: false }) public otpBox6: DxTextBoxComponent;
  valueofOTP: boolean = true;
  otpValue1: string = null;
  otpValue2: string = null;
  otpValue3: string = null;
  otpValue4: string = null;
  otpValue5: string = null;
  otpValue6: string = null;

  ngOnInit() {
    this.config.getLocalStorageData();
    this.phoneNum = this.config.countryTelCode + '-' + this.config.mobNumber;
    this.basicTimer.start();
    setTimeout(() => {
      this.valueofOTP = false;
    }, 120000);
  }

  focusOutFunction(e) {
    if (this.otpValue1 != "") {
      this.otpBox2.instance.focus();
    }
  }
  focusOutFunction1(e) {
    if (this.otpValue2 != "") {
      this.otpBox3.instance.focus();
    }
    if (this.otpValue2 == "") {
      this.otpBox1.instance.focus();
    }
  }
  focusOutFunction2(e) {

    if (this.otpValue3 != "") {
      this.otpBox4.instance.focus();
    }
    if (this.otpValue3 == "") {
      this.otpBox2.instance.focus();
    }
  }
  focusOutFunction3(e) {

    if (this.otpValue4 != "") {
      this.otpBox5.instance.focus();
    }
    if (this.otpValue4 == "") {
      this.otpBox3.instance.focus();
    }
  }
  focusOutFunction4(e) {

    if (this.otpValue5 != "") {
      this.otpBox6.instance.focus();
    }
    if (this.otpValue5 == "") {
      this.otpBox4.instance.focus();
    }
  }
  focusOutFunction5(e) {
    if (this.otpValue6 == "") {
      this.otpBox5.instance.focus();
    }
  }

  onlyNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }


  resendOTPOld() {
   
    this.valueofOTP = true;
    this.clearOTP();
    this.basicTimer.start();
    setTimeout(() => {
      this.valueofOTP = false;
    }, 120000);
    this.loginService.fetchOTP(this.config.mobNumber, this.config.countryCode,this.constructor.name).subscribe(result => {
      if(result["errorCode"] == 0){
      
        localStorage.setItem("twoFactor", result['twoFactor']);
        localStorage.setItem("userCode", result['userId']);
        this.router.navigate(['login-with-otp']);
      }else{
        this.toasterService.pop("error", result["errorMessage"])
      }
      //console.log(result, result['2008'])
      // if(result['2008']){
      //   this.toasterService.pop("error", result['2008']);
      //   this.router.navigate(['fynd-login'])
      // }else if(result['2006']){
      //   this.toasterService.pop("error", result['2006'])
      // }else{
      //   //console.log(result)
      //   localStorage.setItem("twoFactor", result['twoFactor']);
      //   localStorage.setItem("userCode", result['userId']);
      //   /*****To get twoFactor and userId */
      //   this.config.getLocalStorageData();
      //   this.basicTimer.start();
      //   setTimeout(() => {
      //     this.valueofOTP = false;
      //   }, 120000);
      //   //this.router.navigate(['login-with-otp'])
      // }
    })
    
  }
  resendOTP() {

    this.valueofOTP = true;
    this.clearOTP();
    this.basicTimer.start();
    setTimeout(() => {
      this.valueofOTP = false;
    }, 120000);
    this.loginService.fetchOTPV2(this.config.mobNumber, this.config.countryCode, this.config.countryTelCode,this.constructor.name).subscribe(result => {
      if(result["message"]["code"] == 0){
        this.toasterService.pop("success", result["message"]["message"])
        this.router.navigate(['login-with-otp']);
      }else if(result["code"] == 3096){
        this.toasterService.pop("error", result["message"]["message"]);
      }else if(result["code"] == 5006){
        this.toasterService.pop("error",result["message"]["message"]);
      }else if(result["code"] == 3097){
        this.toasterService.pop("error", result["message"]["message"]);
      }else if(result["code"] == 1005){
        this.toasterService.pop("error", result["message"]["message"]);
      }else{
        this.toasterService.pop("error", result["message"]["message"]);
      }
     
    })

  }
  verifyOTPandLoginOld(e) {

    if(this.otpValue1 != null || this.otpValue2 != null || this.otpValue3 != null || this.otpValue4 != null || this.otpValue5 != null || this.otpValue6 != null){
      this.otpNewValue = parseInt(this.otpValue1.concat(
        this.otpValue2,
        this.otpValue3,
        this.otpValue4,
        this.otpValue5,
        this.otpValue6
      ));
      //console.log("OTP", this.otpNewValue, this.otpNewValue.toString(), this.otpNewValue.toString().length)
      if (this.otpNewValue.toString().length == 6) {
        this.loginService.loginWithOTP(this.otpNewValue)
        .subscribe(result => {
        
          if(result["data"]){
            if(result["message"].code == 200){
              this.url = result["data"].data.url;
              localStorage.clear();
              window.location.href = this.url;
            }else if(result["message"].code == 888){
              this.toasterService.pop('error', "Please login after some time!!");
              this.router.navigate(['fynd-login']);
            }else{
              this.toasterService.pop('error', result["message"].cause)
            }
          }else{
            //console.log(result, result['cause'])
            if(result['code'] == 2014){
              //this.clearOTP();
              this.toasterService.pop("error", result['cause']); // Invalid OTP
            }else if(result['code'] == 2015){
              this.toasterService.pop("error", result['cause']); //Number already verified
              this.router.navigate(['fynd-login']);
            }else{
              this.toasterService.pop("error", result['cause'])
              this.router.navigate(['fynd-login']);
            }
            
          }
          }, err=>{
              console.log(err)
              this.toasterService.pop("error", err["error"].cause);
              this.clearOTP();
              //this.router.navigate(['fynd-login'])
          });

      } else {
        this.toasterService.pop("error", "Invalid OTP");
        this.clearOTP();
      }
    }else{
      this.toasterService.pop("error", "Invalid OTP");
    }

    
   
  }
  verifyOTPandLogin(e) {

    if (this.otpValue1 != null || this.otpValue2 != null || this.otpValue3 != null || this.otpValue4 != null || this.otpValue5 != null || this.otpValue6 != null) {
      this.otpNewValue = parseInt(this.otpValue1.concat(
        this.otpValue2,
        this.otpValue3,
        this.otpValue4,
        this.otpValue5,
        this.otpValue6
      ));
      //console.log("OTP", this.otpNewValue, this.otpNewValue.toString(), this.otpNewValue.toString().length)
      if (this.otpNewValue.toString().length == 6) {
        this.loginService.loginWithOTPV2(this.otpNewValue)
          .subscribe(result => {
            console.log("result")
            if (result["data"] && Object.keys(result["data"]).length > 0) {
              if (result["data"].Module === "Login") {    ///if (result["message"].code == 200)
                this.url = result["data"].data.url;
                localStorage.clear();
                window.location.href = this.url;
              } else if (result["message"].code == 888) {
                this.toasterService.pop('error', "Please login after some time!!");// Integrated API Error
                this.router.navigate(['fynd-login']);
              } else if (result["data"].Module === "SignUp") {   //if (result["message"].code == 404 && result["data"].Module === "SignUp") {
                // this.toasterService.pop('error', result["message"].message); //User Not Found
                this.router.navigate(['select-mall']);
              } else {
                this.toasterService.pop('error', result["message"].message)
              }
            } else {

              if (result["message"].code == 2014) {
                this.toasterService.pop("error", result['message'].message); //"OTP is invalid please try again",
              } else if (result["message"].code == 2001) {
                this.toasterService.pop("error", result['message'].message); //country_Code is Not Valid ,Mobile Number is Not Valid,OTP is Not Valid
                this.router.navigate(['fynd-login']);
              } else if (result["message"].code == 3097) {
                this.toasterService.pop("error", result['message'].message); // Please enter the valid telephone code
                this.router.navigate(['fynd-login']);
              } else if (result["message"].code == 2002) {
                this.toasterService.pop("error", result['message'].message); // If provided Wrong CountryCode - Not Found
                this.router.navigate(['fynd-login']);
              } else if (result["message"].code == 2015) {
                this.toasterService.pop("error", result['message'].message); //OTP used or expired. Request a new one.
                this.router.navigate(['fynd-login']);
              }
              else if (result["message"].code == 5002) {
                this.toasterService.pop("error", result['message'].message); //Something Went Wrong.
                this.router.navigate(['fynd-login']);
              } else {
                this.toasterService.pop("error", result["message"].message)
                this.router.navigate(['fynd-login']);
              }

            }
          }, err => {
            console.log(err)
            this.toasterService.pop("error", "Something went wrong. Please try again."); //any network/server failure
            this.clearOTP();
          });

      } else {
        this.toasterService.pop("error", "Invalid OTP");
        this.clearOTP();
        return;
      }
    } else {
      this.toasterService.pop("error", "Invalid OTP");
    }



  }


  clearOTP(){
    this.otpValue1 = null;
    this.otpValue2 = null;
    this.otpValue3 = null;
    this.otpValue4 = null;
    this.otpValue5 = null;
    this.otpValue6 = null;
  }

}
